import React, {Component} from 'react';

export default class TextViewer extends Component {
  render() {
    const {value, placeholder} = this.props;
    return (
      <div className="text-viewer">
        {value.length > 0 && value.split('\n').map((paragraph, i) => {
          return (<span key={i}>{paragraph}<br/></span>);
        })}
        {value.length === 0 && placeholder.split('\n').map((paragraph, i) => {
          return (<span className="placeholder" key={i}>{paragraph}<br/></span>);
        })}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./client/pages/persona/textField/TextViewer.jsx